import type { SrsRating } from '../../ds';
import type { RatingIntervals, ReviewRating } from '../../api/srs.types';

/// Tự đánh giá chỉ có 2 mức; FSRS vẫn nhận 4 mức nhưng app không dùng HARD/EASY.
export const RATING_MAP: Record<SrsRating, ReviewRating> = { chuaThuoc: 'AGAIN', daThuoc: 'GOOD' };

export function toButtonIntervals(intervals: RatingIntervals): Record<SrsRating, number> {
  return { chuaThuoc: intervals.AGAIN, daThuoc: intervals.GOOD };
}
